import { IPromise, IQService } from 'angular';

export function allSettled<T>($q: IQService, promises: IPromise<T>[]) {
  const toSettle = [] as IPromise<T>[];

  if (Array.isArray(promises)) {
    promises.forEach((promise) => {
      const deferred = $q.defer<T>();
      promise.then(deferred.resolve, deferred.resolve);
      toSettle.push(deferred.promise);
    });
  }

  return $q.all(toSettle);
}
